import {
  IS_INCLUSIVE_BETW_JAN1_TO_JUN30,
  IS_INCLUSIVE_BETW_SEPT16_TO_DEC31,
  START_OF_CURRENT_JULY,
  START_OF_LAST_JULY,
} from "@/reports/constants";

/*
  - Between Jan 1st and before July 1st: show option and use previous year's july; default option: july to date
  - July 1st to Sept 15th: hide option july to date: default option: last 45 days for admins and last 30 days for teachers
  - From after Sept 15th to Dec 31st: show option and use current year's july; default option: july to date
  - default is last 45 days in case someone bookmarks july to date option during its hidden period
  */
const getMinimumDate = (defaultMinDate: string) =>
  IS_INCLUSIVE_BETW_JAN1_TO_JUN30
    ? START_OF_LAST_JULY
    : IS_INCLUSIVE_BETW_SEPT16_TO_DEC31
      ? START_OF_CURRENT_JULY
      : defaultMinDate;

export default getMinimumDate;
